import router from '../router'

const messages = [
  '🔥 Sarah just booked a hibachi party in Destin!',
  '🎉 Marcus booked 15 guests in Panama City Beach',
  '⭐ 5-star review from Jennifer in 30A',
  '🔥 Ashley booked a bachelorette party in Seaside',
  '🎂 Birthday party booked in Fort Walton Beach!',
  '⭐ "Best party ever!" - Mike, Destin',
  '🔥 20-person hibachi party booked in Miramar Beach',
  '🎉 Wedding rehearsal dinner booked in Rosemary Beach'
]

let messageIndex = 0
let popupTimer = null

const initAnimations = () => {
  const fadeEls = document.querySelectorAll('.section-title,.section-desc,.menu-card,.review,.step,.gallery-item,.exp-features li,.section-label')
  if ('IntersectionObserver' in window && fadeEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible')
          io.unobserve(entry.target)
        }
      })
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' })
    fadeEls.forEach((el, index) => {
      el.classList.add('fade-in')
      el.style.transitionDelay = `${(index % 4) * 0.08}s`
      io.observe(el)
    })
  } else {
    fadeEls.forEach((el) => el.classList.add('visible'))
  }
}

const initVideos = () => {
  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.addEventListener('loadeddata', () => video.play().catch(() => {}), { once: true })
    window.setTimeout(() => {
      if (video.paused) video.play().catch(() => {})
    }, 1000)
  })
}

const initParticles = () => {
  const container = document.getElementById('particles')
  if (!container || container.dataset.vueParticles) return
  container.dataset.vueParticles = 'true'
  for (let i = 0; i < 20; i++) {
    const p = document.createElement('div')
    p.className = 'particle'
    p.style.left = `${Math.random() * 100}%`
    p.style.animationDelay = `${Math.random() * 8}s`
    p.style.animationDuration = `${6 + Math.random() * 6}s`
    p.style.width = p.style.height = `${1 + Math.random() * 2}px`
    container.appendChild(p)
  }
}

const initSocialProof = () => {
  const popup = document.getElementById('spPopup')
  if (!popup || popup.dataset.vuePopup) return
  popup.dataset.vuePopup = 'true'
  const show = () => {
    popup.textContent = messages[messageIndex % messages.length]
    popup.classList.add('show')
    window.setTimeout(() => popup.classList.remove('show'), 4000)
    messageIndex += 1
  }
  popupTimer = window.setTimeout(() => {
    show()
    popupTimer = window.setInterval(show, 12000)
  }, 5000)
}

const initParallax = () => {
  const heroContent = document.querySelector('.hero-content')
  if (!heroContent || heroContent.dataset.vueParallax) return
  heroContent.dataset.vueParallax = 'true'
  window.addEventListener('scroll', () => {
    const y = window.scrollY
    if (y < window.innerHeight) {
      heroContent.style.transform = `translateY(${y * 0.3}px)`
      heroContent.style.opacity = String(1 - y / (window.innerHeight * 0.8))
    }
  }, { passive: true })
}

const initPage = () => {
  if (popupTimer) {
    window.clearTimeout(popupTimer)
    window.clearInterval(popupTimer)
    popupTimer = null
  }
  initAnimations()
  initVideos()
  initParticles()
  initSocialProof()
  initParallax()
}

router.afterEach(() => window.setTimeout(initPage, 0))
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPage, { once: true })
} else {
  initPage()
}
